'use client';

import { useQuery } from '@tanstack/react-query';

import { useTranslations } from 'next-intl';
import Pagination from '@/components/shared/Pagination';
import SearchBar from '@/components/shared/SearchBar';
import { useScrollIntoViewOnChange } from '@/hooks/useScrollIntoViewOnChange';
import { useUrlSearch } from '@/hooks/useUrlSearch';
import { cn } from '@/utils/cn';
import { ProviderListContent } from './components/ProviderListContent';
import {
  providerListQueryOptions,
  PROVIDERS_LIST_DESKTOP_PAGE_SIZE,
} from './providerList.queries';

interface ProviderListProps {
  className?: string;
}

export default function ProviderList({ className }: ProviderListProps) {
  const t = useTranslations('providers.providers-list');

  const { searchValue, setSearchValue, searchParam, pageParam, setPageParam } = useUrlSearch({ searchKey: 'q' });
  const sectionRef = useScrollIntoViewOnChange(pageParam);

  const pageSizes = PROVIDERS_LIST_DESKTOP_PAGE_SIZE;

  const { data: providersData, isFetching } = useQuery(providerListQueryOptions({
    page: pageParam,
    search: searchParam,
    limit: pageSizes,
  }));

  const pageSize = providersData?.totalPages || pageSizes;
  const totalItems = providersData?.totalItems || 0;

  return (
    <section ref={sectionRef} className={cn('scroll-m-25', className)}>

      <div className="relative w-full">
        <SearchBar
          query={searchValue}
          clearSearch={() => setSearchValue('')}
          onChange={e => setSearchValue(e.target.value)}
          placeholder={t('search-placeholder')}

        />
        <ProviderListContent
          isFetching={isFetching}
          defaultPageSize={pageSizes}
          items={providersData?.items}
        />

      </div>
      {
        totalItems > pageSizes && (
          <Pagination
          // TODO: add variant link
            totalPages={pageSize}
            totalItems={totalItems}
            className="mt-10 md:mt-6"
            onPageChangeAction={setPageParam}
            pageNumber={providersData?.page || 1}
          />
        )
      }

    </section>
  );
};
